<template>
  <div>
    <el-container>
      <el-header>
        <div style="margin: 20px 0">
          <el-button type="primary" @click="openCreateWOA(1)" size="small" v-show="isWeChat">创建</el-button>
        </div>
      </el-header>
      <el-main>
        <el-dialog  title="创建/编辑" :visible.sync="dialogFormVisible" :fullscreen="true" width="100%" top="0vh">
          <el-form label-position="right" label-width="180px">
            <el-form-item label="第三方平台名称">
              <el-input placeholder="请输入第三方平台名称" v-model="name"  clearable :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="开发者ID">
              <el-input placeholder="请输入开发者ID(AppID)" v-model="appId"  clearable :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="开发者密码">
              <el-input placeholder="请输入开发者密码(AppSecret)" v-model="appSecret"  clearable :maxlength="50" ></el-input>
            </el-form-item>
            <el-form-item label="消息加解密密钥">
              <el-input placeholder="请输入消息加解密密钥(Key)" v-model="key"  clearable :maxlength="50" ></el-input>
            </el-form-item>
            <el-form-item label="消息校验Token">
              <el-input placeholder="请输入消息校验Token" v-model="token"  clearable :maxlength="50" ></el-input>
            </el-form-item>
            <el-form-item label="第三方平台logo">
              <el-input placeholder="请输入第三方平台logo" v-model="logoUrl"  clearable :maxlength="100" ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="closeCreateWOA">取 消</el-button>
            <el-button type="primary" @click="qdCreateWOA">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog
          title="提示"
          :visible.sync="centerDialogVisible"
          width="30%"
          center>
          <span>删除后将无法恢复，确定删除？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="WOADeleteOK">确 定</el-button>
          </span>
        </el-dialog>
        <template>
          <el-table
            :data="tableData"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="name"
              label="第三方平台名称"
              width="320">
            </el-table-column>
            <el-table-column
              prop="appId"
              label="开发者ID"
              width="220">
            </el-table-column>
            <el-table-column
              prop="appSecret"
              label="开发者密码"
              width="220">
            </el-table-column>
            <el-table-column
              prop="key"
              label="加解密密钥"
              width="220">
            </el-table-column>
            <el-table-column
              prop="token"
              label="消息校验Token"
              width="220">
            </el-table-column>
            <el-table-column
              prop="component_verify_ticket"
              label="验证票据"
              width="220">
            </el-table-column>
            <el-table-column
              prop="logoUrl"
              label="第三方平台logo"
              width="120">
              <template slot-scope="scope">
                <img :src="scope.row.logoUrl"  min-width="70" height="70" />
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              :formatter="formatTime"
              label="创建时间"
              width="260">
            </el-table-column>
            <el-table-column
              prop="updateTime"
              :formatter="formatTime"
              label="最后修改时间"
              width="260">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button @click="updateWOA(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                <el-button type="text" @click="deleteWOA(scope.$index, scope.row)" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  export default {
    name: 'weChatThirdPlatform',
    data(){
      return {
        centerDialogVisible:false,
        dialogFormVisible:false,
        isWeChat:false,
        tableData:[],
        data: [],
        key:"",
        token:"",
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        name:"",
        appId:"",
        appSecret:"",
        logoUrl:"",
        isId:"",
        divHeight:500
      }
    },
    methods: {
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy-MM-dd hh:mm:ss";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      openCreateWOA:function (val) {
        this.isType = val;
        this.dialogFormVisible = true;
      },
      closeCreateWOA:function () {
        this.dialogFormVisible = false;
      },
      qdCreateWOA:function () {
        if(this.name == ""){
          this.$message({
            message: "请输入第三方平台名称",
            type: 'warning'
          });
          return false;
        }else if(this.appId == ""){
          this.$message({
            message: "开发者ID",
            type: 'warning'
          });
          return false;
        }else if(this.appSecret == ""){
          this.$message({
            message: "请输入开发者密码",
            type: 'warning'
          });
          return false;
        }else if(this.key == ""){
          this.$message({
            message: "请输入消息加解密密钥",
            type: 'warning'
          });
          return false;
        }else if(this.token == ""){
          this.$message({
            message: "请输入消息校验Token",
            type: 'warning'
          });
          return false;
        }else{
          this.isAjax();
        }
        this.closeCreateWOA();
        this.name = "";
        this.appId = "";
        this.key = "";
        this.token = "";
        this.appSecret = "";
        this.logoUrl = "";
      },
      isAjax:async function(val){
        await this.$axios.post('/root/WTPMessage',{
          "t":this.isType,
          "name":this.name,
          "appId":this.appId,
          "appSecret":this.appSecret,
          "key":this.key,
          "token":this.token,
          "logoUrl":this.logoUrl,
          "id":this.isId
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.$message({
              message: response.message,
              type: 'success'
            });
            this.addWTP();
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      addWTP:async function(){
        await this.$axios.post('/root/addWTP',{
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data[0];
            this.allcount0 = response.data[1];
            if(this.tableData.length == 0){
              this.isWeChat = true;
            }
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
        this.divHeight = window.innerHeight-158;
      },
      updateWOA(index, row) {
        this.openCreateWOA(3);
        this.isId = row._id;
        this.name = row.name;
        this.appId = row.appId;
        this.appSecret = row.appSecret;
        this.key = row.key;
        this.token = row.token;
        this.logoUrl = row.logoUrl;
      },
      deleteWOA(index, row) {
        this.isType = 2;
        this.isId = row._id;
        this.centerDialogVisible = true;
      },
      WOADeleteOK(){
        this.isAjax("");
        this.addWTP();
        this.centerDialogVisible = false;
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.addWTP();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.addWTP();
      }
    },
    mounted:function () {
      this.addWTP();
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/main/weChatThirdPlatform.vue